import React from 'react';
import Portfolio from './components/Portofolio/Portfolio.js';

function App() {
  return <Portfolio />;
}

export default App;
